import React, {  useEffect, useState, useMemo } from 'react'
import { Breadcrumb, CardBasic, ModalForm, ModalInfo, SButton, TextInputWithLabel } from '../../components'
import { Ceklis } from '../../assets'
import { Form } from 'react-bootstrap'
import ShowAlert from '../../components/ShowAlert';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { API_BASE_URL } from '../../config';
import { set } from 'react-hook-form';

function Checkout() {
    const [showModal, setShowModal] = useState(false);
    const [fields, setFields] = useState([]);

    const navigate = useNavigate();

    // const orderItems = JSON.parse(localStorage.getItem('orderItems')) || [];
    const [orderItems, setOrderItems] = useState(() => JSON.parse(localStorage.getItem('orderItems')) || []);
    const workers = useMemo(() => JSON.parse(localStorage.getItem('workers')) || [], []);
    const patients = JSON.parse(localStorage.getItem('patients')) || [];
    const packages = patients?.package || [];

    const [amount, setAmount] = useState(0);
    const [isAmountTouched, setIsAmountTouched] = useState(false);
    const [payments, setPayments] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState('card'); // default, bisa diubah sesuai radio
    const [showBankModal, setShowBankModal] = useState(false);
    const [selectedBank, setSelectedBank] = useState('Mandiri');

    const [showWalletModal, setShowWalletModal] = useState(false);
    const [selectedWallet, setSelectedWallet] = useState('OVO');

    const [isSaving, setIsSaving] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [noTransaction, setNoTransaction] = useState('');
    const [showNotif, setShowNotif] = useState(false);
    
    const [notifType, setNotifType] = useState('success');
    const [notifMessage, setNotifMessage] = useState('Form has been successfully submitted!');

    const user = useSelector((state) => state.auth);
    const location = useLocation();
    const data = location.state;

    useEffect(() => {
        // Hitung grand total sesuai diskon per item
        const grandTotal = orderItems.reduce((sum, item) => {
            const worker = workers.length > 0 ? workers.find(w => w.order.id === item.id) : null;
            if (!worker || worker.discount_type === 'none') {
                return sum + ((item.unit_price ?? 0) * item.quantity);
            }
            if (worker.discount_type === 'percentage') {
                const discount = (worker.order?.discount || 0);
                const total = ((item.unit_price ?? 0) * item.quantity);
                return sum + (total - (total * discount / 100));
            }
            if (worker.discount_type === 'fixed') {
                const discount = Number(worker.order?.discount || 0);
                const total = ((item.unit_price ?? 0) * item.quantity);
                return sum + (total - discount);
            }
            return sum + ((item.unit_price ?? 0) * item.quantity);
        }, 0);
        // Hanya set amount otomatis jika belum pernah diedit user
        if (!isAmountTouched && (!amount || amount === 0)) {
            setAmount(grandTotal);
        }
    }, [orderItems, workers, amount, isAmountTouched]);


    const HeaderPos = ({ amount }) => {
        const [showModalRiwayat, setShowModalRiwayat] = useState(false);
        const [showModalAdd, setShowModalAdd] = useState(false);
        const [modalGrandTotal, setModalGrandTotal] = useState(0);
        const [modalJumlah, setModalJumlah] = useState(0);
        const [modalDeposito, setModalDeposito] = useState(0);

        const modalRiwayat = () => {
            setShowModalRiwayat(true);
        }

        const addPayment = () => {
            const pkg = packages.find(pkg => {
                const item = orderItems.find(oi => oi.item_id === pkg.treatment.id);
                return item && item.type === 'treatment';
            });
            if(pkg){
                if(pkg.used_qty >= pkg.total_qty){
                    setNotifMessage('Jumlah paket sudah terpakai semua!');
                    setShowNotif(true);
                    setNotifType('warning');
                    return;
                }
            }

            if(!pkg){
                if (!amount || amount === '0') return;  
            }
            if (paymentMethod === 'card') {
                setShowBankModal(true);
                return;
            }

            if (paymentMethod === 'ewallet') {
                setShowWalletModal(true);
                return;
            }
            setPayments(prev => [
                ...prev,
                {
                    type: paymentMethod,
                    select: paymentMethod === 'cash' ? 'Cash' : '',
                    amount: amount
                }
            ]);
            setAmount('0'); // reset input setelah tambah
        };

        const handleBankSelect = (bank) => {
            setSelectedBank(bank);
            setPayments(prev => [
                ...prev,
                {
                    type: paymentMethod,
                    select: bank,
                    amount: amount
                }
            ]);
            setShowBankModal(false);
            setAmount('0');
        };

        const handleWalletSelect = (wallet) => {
            setSelectedWallet(wallet);
            setPayments(prev => [
                ...prev,
                {
                    type: paymentMethod,
                    select: wallet,
                    amount: amount
                }
            ]);
            setShowWalletModal(false);
            setAmount('0');
        }

        const handleUseDeposit = () => {
            if (!patients?.total_deposit || patients.total_deposit === 0) {
                setNotifMessage('Deposit tidak tersedia atau 0!');
                setShowNotif(true);
                setNotifType('warning');
                setShowModalRiwayat(false);
                return;
            }
            setPayments(prev => [
                ...prev,
                {
                    type: 'Deposit',
                    select: 'Deposit',
                    amount: patients?.total_deposit || 0
                }
            ]);
            setShowModalRiwayat(false);
            setAmount('0');
        };

        const payNow = (e) => {
            e.preventDefault();
            if (isSubmitted) return; 
            if (payments.length === 0) return;
            if (orderItems.length === 0) return;
            if (workers.length === 0) return;
            if (patients.length === 0) return;
            
            // Hitung grand total
            const grandTotal = orderItems.reduce((sum, item) => {
                const worker = workers.length > 0 ? workers.find(w => w.order.id === item.id) : null;
                if (!worker || worker.discount_type === 'none') {
                    return sum + ((item.unit_price ?? 0) * item.quantity);
                }
                if (worker.discount_type === 'percentage') {
                    const discount = (worker.order?.discount || 0);
                    const total = ((item.unit_price ?? 0) * item.quantity);
                    return sum + (total - (total * discount / 100));
                }
                if (worker.discount_type === 'fixed') {
                    const discount = Number(worker.order?.discount || 0);
                    const total = ((item.unit_price ?? 0) * item.quantity);
                    return sum + (total - discount);
                }
                return sum + ((item.unit_price ?? 0) * item.quantity);
            }, 0);

            // Hitung total pembayaran
            const totalPayment = payments.reduce((sum, pay) => sum + Number(pay.amount), 0);
        
            if (totalPayment > grandTotal) {
                // Tampilkan modal jika pembayaran melebihi grand total
                setModalGrandTotal(grandTotal);
                setModalJumlah(totalPayment);
                setModalDeposito(totalPayment - grandTotal);
                setShowModalAdd(true);
            } else if (totalPayment < grandTotal) {
                setNotifMessage('Total pembayaran kurang dari grand total!');
                setShowNotif(true);
                setNotifType('danger');
                setIsSaving(false);
            } else {
                setIsSaving(true);
                const transactionData = {
                    no_medical_record: patients?.patient?.no_medical_record,
                    klinik_id: data?.klinik_id,
                    no_regist: data?.no_regist,
                    total_amount: grandTotal,
                    total_paid: totalPayment,
                    patient: patients,
                    items: orderItems,
                    payments: payments,
                    workers: workers,
                    user_id: user?.user?.id || null,
                    date: new Date().toISOString(),
                    noTransaction: noTransaction,
                }
                
                try {
                    const token = localStorage.getItem('access_token');
                    
                    fetch(`${API_BASE_URL}/auth/pos/complete`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        },
                        body: JSON.stringify(transactionData)
                    })
                    .then(response => {
                        if (!response.ok) {
                            return response.json().then(errorData => {
                                throw new Error(errorData.message || 'Gagal melakukan payment!');
                            });
                        }
                        return response.json();
                    })
                    .then(result => {
                        setNotifMessage(result.message || 'Payment successful!');
                        setShowNotif(true);
                        setNotifType('success');
                        setIsSaving(false);
                        setIsSubmitted(true);
                        setNoTransaction(result?.data?.no_transaction || '');
                        navigate('/pos/receipt', { 
                            state: { 
                                transaction: { ...transactionData, no_transaction: result?.data?.no_transaction || '' , transaction_id: result?.data?.transaction_id || '' } 
                            } 
                        });
                    })
                    .catch(error => {
                        setNotifMessage(error.message || 'Gagal melakukan payment!');
                        setShowNotif(true);
                        setNotifType('danger');
                        setIsSaving(false);
                    });
                } catch (error) {
                    setNotifMessage('Gagal melakukan payment!');
                    setShowNotif(true);
                    setNotifType('danger');
                    setIsSaving(false);
                }
            }
        };

        const handleCloseModal = () => {
            setShowModalRiwayat(false);
            setShowModalAdd(false);
        };


        const handleSubmitAddDeposit = async (e) => {
            e.preventDefault();
            const transactionData = {
                no_medical_record: patients?.patient?.no_medical_record,
                klinik_id: data?.klinik_id,
                no_regist: data?.no_regist,
                total_amount: modalGrandTotal,
                total_paid: modalJumlah,
                patient: patients,
                items: orderItems,
                payments: payments,
                workers: workers,
                user_id: user?.user?.id || null,
                date: new Date().toISOString(),
                noTransaction: noTransaction,
            }

            setIsSaving(true);
            try {
                const token = localStorage.getItem('access_token');
                
                const response = await fetch(`${API_BASE_URL}/auth/pos/complete`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                    body: JSON.stringify(transactionData)
                });
                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    setNotifMessage(errorData.message || 'Gagal melakukan payment!');
                    setShowNotif(true);
                    setNotifType('danger');
                    setIsSaving(false);
                    return;
                }
                const result = await response.json();
                setNotifMessage(result.message || 'Payment successful!');
                setShowNotif(true);
                setNotifType('success');
                setIsSaving(false);
                setIsSubmitted(true);
                setNoTransaction(result?.data?.no_transaction || '');
                navigate('/pos/receipt', { 
                    state: { 
                        transaction: { ...transactionData, no_transaction: result?.data?.no_transaction || '' , transaction_id: result?.data?.transaction_id || '' }
                    } 
                });
            } catch (error) {
                setNotifMessage('Gagal melakukan payment!');
                setShowNotif(true);
                setNotifType('danger');
                setIsSaving(false);
            }
            setShowModalAdd(false);
        }


        return (
            <>
                <div className='col-lg-6 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                    >
                        <h5 className='fs-1hx fw-bold'>
                            Data Patient
                        </h5>
                        <div className='fs-6 fw-semibold text-gray-400 mb-7'>
                            <span>Latest social statistics</span>
                        </div>
                        <div className='fs-7 d-flex justify-content-between mb-4'>
                            <div className='fw-semibold'>{patients?.patient?.full_name}</div>
                        </div>
                        <div className="separator separator-dashed"></div>
                        <div className='fs-7 d-flex justify-content-between mb-4'>
                            <div className='fw-semibold'>{patients?.patient?.no_medical_record}</div>
                        </div>
                        <div className="separator separator-dashed"></div>
                        <div className='fs-7 d-flex justify-content-between mb-4'>
                            <div className='fw-semibold'>Platinum</div>
                        </div>
                    </CardBasic>
                </div>
                <div className='col-lg-6 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                    >
                        <h5 className='fs-1hx fw-bold'>
                            Credit/Deposit
                        </h5>
                        <div className='fs-6 fw-semibold text-gray-400 mb-7'>
                            <span>Credit logs or Deposit logs</span>
                        </div>
                        <div className="separator separator-dashed mb-4"></div>
                        <div className='fs-6 d-flex justify-content-between align-items-center mb-4'>
                            <div className='fw-semibold text-success'>{patients?.deposit && patients?.deposit != null ? `Rp. ${Number(patients?.total_deposit).toLocaleString('id-ID')}` : 'No Deposit Available'}</div>
                            <SButton 
                                variant={'info'}
                                className={'btn-outline-info btn-light-info'}
                                size={'sm'}
                                type={'button'}
                                action={() => modalRiwayat()}
                            >
                                Riwayat
                            </SButton>
                        </div>
                    </CardBasic>
                </div>
                <div className='col-lg-12 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                    >
                        <h5 className='fs-1hx fw-bold'>
                            Treatment/Product
                        </h5>
                        <div className='fs-6 fw-semibold text-gray-400 mb-7'>
                            <span>Items</span>
                        </div>
                        <div className='table'>
                            <div className="table-responsive">
                                <table className="table table-bordered align-middle mb-0">
                                    <thead className='fw-bold'>
                                        <tr>
                                        <th>Treatment</th>
                                        <th className='text-end'>Qty</th>
                                        <th className='text-center'>Pkt</th>
                                        <th className='text-center' style={{width:'40px'}}>Action</th>
                                        <th className='text-end'>Final Price</th>
                                        <th className='text-end'>Discount</th>
                                        <th className='text-end'>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderItems.length === 0 ? (
                                            <tr>
                                                <td colSpan={7} className="text-center text-muted">Belum ada order</td>
                                            </tr>
                                        ) : (
                                            orderItems.map((item, idx) => (
                                                <tr key={item.id || idx}>
                                                    <td>{item.name}</td>
                                                    <td className='text-end'>{item.quantity}</td>
                                                    <td className='text-center'>
                                                        {item.type !== 'treatment'
                                                         ? '-'
                                                         : (() => {
                                                            const pkg = packages.find(pkg => pkg.treatment.id === item.item_id);
                                                            if (pkg) {
                                                                return `${pkg.used_qty ?? 0}/${pkg.total_qty ?? 0}`;
                                                            }
                                                            return '0/'+ (item.quantity_real > 1 ? item.quantity_real : item.quantity);
                                                         })()
                                                        }
                                                    </td>
                                                    <td className='text-center' style={{ justifyItems: 'center' }}>
                                                        <input
                                                            type="number"
                                                            min={1}
                                                            max={100}
                                                            value={item.used_qty ?? 1}
                                                            name={`used_qty_${item.id}`}
                                                            id={`used_qty_${item.id}`}
                                                            style={{ width: 60 }}
                                                            className="form-control"
                                                            onChange={e => {
                                                                const qty = Math.max(1, Math.min(100, Number(e.target.value)));
                                                                if (qty > ( item.quantity_real > 1 ? item.quantity_real : item.quantity )) {
                                                                    setNotifMessage('Used quantity tidak boleh lebih besar dari quantity order!');
                                                                    setShowNotif(true);
                                                                    setNotifType('warning');
                                                                    return;
                                                                }
                                                                setOrderItems(prev =>
                                                                    prev.map((itm, i) =>
                                                                        i === idx ? { ...itm, used_qty: qty } : itm
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td className='text-end'>{Number(item.unit_price * item.quantity).toLocaleString('id-ID')}</td>
                                                    <td className='text-end'>
                                                        {
                                                            (() => {
                                                                const worker = workers.length > 0 ? workers.find(w => w.order.id === item.id) : null;
                                                                if (!worker) return '';
                                                                if (worker.discount_type === 'percentage') {
                                                                    return (worker.order?.discount || 0) + '%';
                                                                }
                                                                if (worker.discount_type === 'fixed') {
                                                                    return Number(worker.order?.discount || 0).toLocaleString('id-ID');
                                                                }
                                                                if(worker.discount_type === 'none') {
                                                                    return 0;
                                                                }
                                                                return 0;
                                                            })()
                                                        }
                                                    </td>
                                                    <td className='text-end'>
                                                        {
                                                            (() => {
                                                                const worker = workers.length > 0 ? workers.find(w => w.order.id === item.id) : null;
                                                                if (!worker) return 0;
                                                                if (worker.discount_type === 'percentage') {
                                                                    return Number( (item.final_price ?? 0) - ((item.unit_price ?? 0) * item.quantity ) * (worker.order?.discount || 0) / 100).toLocaleString('id-ID');
                                                                }
                                                                if (worker.discount_type === 'fixed') {
                                                                    return Number(((item.unit_price ?? 0) * item.quantity) - worker.order?.discount).toLocaleString('id-ID');
                                                                }
                                                                if(worker.discount_type === 'none') {
                                                                    return Number((item.unit_price ?? 0) * item.quantity).toLocaleString('id-ID');
                                                                }

                                                                return 0;
                                                            })()
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                        {orderItems.length > 0 && (() => {
                                            // Subtotal: total harga sebelum diskon
                                            const subtotal = orderItems.reduce((sum, item) => sum + ((item.unit_price ?? 0) * item.quantity), 0);
                                            // Grand total: total harga setelah diskon per item
                                            const grandTotal = orderItems.reduce((sum, item) => {
                                                const worker = workers.length > 0 ? workers.find(w => w.order.id === item.id) : null;
                                                if (!worker || worker.discount_type === 'none') {
                                                    return sum + ((item.unit_price ?? 0) * item.quantity);
                                                }
                                                if (worker.discount_type === 'percentage') {
                                                    const discount = (worker.order?.discount || 0);
                                                    const total = ((item.unit_price ?? 0) * item.quantity);
                                                    return sum + (total - (total * discount / 100));
                                                }
                                                if (worker.discount_type === 'fixed') {
                                                    const discount = Number(worker.order?.discount || 0);
                                                    const total = ((item.unit_price ?? 0) * item.quantity);
                                                    return sum + (total - discount);
                                                }
                                                return sum + ((item.unit_price ?? 0) * item.quantity);
                                            }, 0);
                                            return (
                                                <>
                                                    <tr>
                                                        <td colSpan={5}></td>
                                                        <td className="fw-bold text-end">Subtotal</td>
                                                        <td className="fw-bold text-end">{subtotal.toLocaleString('id-ID')}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={5}></td>
                                                        <td className="fw-bold text-end text-primary">Grand Total</td>
                                                        <td className="fw-bold text-end text-primary">{grandTotal.toLocaleString('id-ID')}</td>
                                                    </tr>
                                                </>
                                            );
                                        })()}
                                    </tbody>
                                </table>
                            </div>
                           
                        </div>
                    </CardBasic>
                </div>
                <div className='col-lg-6 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                    >
                        <h5 className='fs-1hx fw-bold mb-5'>
                            Payment Method
                        </h5>
                        <Form>
                            <div className='fs-6 d-flex justify-content-between align-items-center mb-4'>
                                <div className='d-flex flex-equal gap-5 gap-xxl-9 px-0 mb-12'>
                                    <input
                                        className='btn-check'
                                        type='radio'
                                        name='method'
                                        id='method-cash'
                                        value='cash'
                                        checked={paymentMethod === 'cash'}
                                        onChange={() => setPaymentMethod('cash')}
                                    />
                                    <label htmlFor='method-cash' className='btn bg-light btn-color-gray-600 btn-active-text-gray-800 border border-3 border-gray-100 border-active-primary btn-active-light-primary w-100 px-4'>
                                        <i className="ki-outline ki-bill fs-2hx mb-2 pe-0"></i>
                                        <span className="fs-7 fw-bold d-block">Cash</span>
                                    </label>
                                    <input
                                        className='btn-check'
                                        type='radio'
                                        name='method'
                                        id='method-card'
                                        value='card'
                                        checked={paymentMethod === 'card'}
                                        onChange={() => setPaymentMethod('card')}
                                    />  
                                    {showBankModal && (
                                        <ModalInfo
                                            show={showBankModal}
                                            handleClose={() => setShowBankModal(false)}
                                            title={'Pilih Bank'}
                                            content={
                                                <>
                                                    <div className="d-flex gap-4 justify-content-center align-items-center py-4">
                                                        {['BCA','BNI', 'Mandiri', 'BRI'].map(bank => (
                                                            <div
                                                                key={bank}
                                                                className={`card p-3 text-center cursor-pointer ${selectedBank === bank ? 'border-primary' : 'border-light'}`}
                                                                style={{ minWidth: 120, minHeight: 80, boxShadow: '0 2px 8px #eee', border: '2px solid', borderRadius: 8 }}
                                                                onClick={() => handleBankSelect(bank)}
                                                            >
                                                                <img src={require(`../../assets/image/${bank.toUpperCase()}.png`)} alt={bank} style={{ height: 32, marginBottom: 8 }} />
                                                                <div className="fw-bold">{bank}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </>
                                            }
                                        />
                                    )}
                                    <label htmlFor='method-card' className='btn bg-light btn-color-gray-600 btn-active-text-gray-800 border border-3 border-gray-100 border-active-primary btn-active-light-primary w-100 px-4'>
                                        <i className="ki-outline ki-credit-cart fs-2hx mb-2 pe-0"></i>
                                        <span className="fs-7 fw-bold d-block">Card</span>
                                    </label>
                                    <input
                                        className='btn-check'
                                        type='radio'
                                        name='method'
                                        id='method-ewallet'
                                        value='ewallet'
                                        checked={paymentMethod === 'ewallet'}
                                        onChange={() => setPaymentMethod('ewallet')}
                                    />
                                    {showWalletModal && (
                                        <ModalInfo
                                            show={showWalletModal}
                                            handleClose={() => setShowWalletModal(false)}
                                            title={'Pilih E-Wallet'}
                                            content={
                                                <>
                                                    <div className="d-flex gap-4 justify-content-center align-items-center py-4">
                                                        {['OVO','GOPAY', 'SHOPEE', 'QRIS'].map(wallet => (
                                                            <div
                                                                key={wallet}
                                                                className={`card p-3 text-center cursor-pointer ${selectedWallet === wallet ? 'border-primary' : 'border-light'}`}
                                                                style={{ minWidth: 120, minHeight: 80, boxShadow: '0 2px 8px #eee', border: '2px solid', borderRadius: 8 }}
                                                                onClick={() => handleWalletSelect(wallet)}
                                                            >
                                                                <img src={require(`../../assets/image/${wallet.toUpperCase()}.png`)} alt={wallet} style={{ height: 32, marginBottom: 8 }} />
                                                                <div className="fw-bold">{wallet}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </>
                                            }
                                        />
                                    )}
                                    <label  htmlFor='method-ewallet' className='btn bg-light btn-color-gray-600 btn-active-text-gray-800 border border-3 border-gray-100 border-active-primary btn-active-light-primary w-100 px-4'>
                                        <i className="ki-outline ki-wallet fs-2hx mb-2 pe-0"></i>
                                        <span className="fs-7 fw-bold d-block">E-Wallet</span>
                                    </label>
                                </div>
                            </div>
                            <div className='fs-6 d-flex flex-column mb-4'>
                                <label className='text-gray-800 fs-6 fw-bold mb-3'>Amount</label>
                                <input
                                    type='text'
                                    name='amount'
                                    className='form-control'
                                    value={amount}
                                    onChange={e => {
                                        setIsAmountTouched(true);
                                        // Hanya izinkan angka
                                        const value = e.target.value.replace(/[^0-9]/g, '');
                                        setAmount(value);
                                    }}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    autoFocus
                                />
                            </div>
                            <div className='d-flex'>
                                <SButton 
                                    variant={'primary'}
                                    className={'btn-primary'}
                                    size={'sm'}
                                    type={'button'}
                                    action={() => addPayment()}
                                >
                                    Add
                                </SButton>
                            </div>
                        </Form>
                    </CardBasic>
                </div>
                <div className='col-lg-6 col-sm-12 p-3'>
                    <CardBasic
                        className={'h-100'}
                        className2={'p-9'}
                    >
                        <h5 className='fs-1hx fw-bold'>
                            Payment
                        </h5>
                        <Form onSubmit={payNow}>
                        <div className='fs-6 d-flex justify-content-between align-items-center mb-4'>
                            <div className='table'>
                                <div className="table-responsive">
                                    <table className="table table-bordered align-middle mb-0">
                                        <thead className='fw-semibold text-gray-500'>
                                            <tr>
                                            <th>Type Of Payment</th>
                                            <th>Payment Select</th>
                                            <th className='text-end'>Payment Amount</th>
                                            <th className='text-end'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {payments.map((pay, idx) => (
                                                <tr key={idx}>
                                                    <td>{pay.type.charAt(0).toUpperCase() + pay.type.slice(1)}</td>
                                                    <td>{pay.select}</td>
                                                    <td className='text-end'>{Number(pay.amount).toLocaleString('id-ID')}</td>
                                                    <td className='text-end'>
                                                        <button
                                                            type="button"
                                                            className="btn btn-icon btn-sm btn-light btn-icon-danger"
                                                            onClick={() => {
                                                                setPayments(prev => prev.filter((_, i) => i !== idx));
                                                            }}
                                                        >
                                                            <i className="ki-outline ki-trash fs-2 text-danger"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan={2}></td>
                                                <td className="fw-bold text-end">Total</td>
                                                <td className="fw-bold text-end">
                                                    {payments.reduce((sum, pay) => sum + Number(pay.amount), 0).toLocaleString('id-ID')}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className='fs-6 d-flex justify-content-center align-items-center mb-4'>
                            <SButton 
                                variant={'primary'}
                                className={'btn-primary'}
                                size={'sm'}
                                type={'submit'}
                                disabled={
                                    payments.length === 0
                                }
                                // disabled={isSaving || isSubmitted}
                            >
                                Pay Now
                            </SButton>
                        </div>
                        </Form>
                    </CardBasic>
                </div>
                { showModalRiwayat && (
                    <ModalInfo 
                        title={'Deposit'}
                        handleClose={handleCloseModal}
                        content={
                            <div>
                                <div className='d-flex flex-column mb-3'>
                                    <span className='fw-semibold fs-6 text-gray-600 m-5'>Pasien ini memiliki deposit sebesar :</span>
                                    <div className='d-flex justify-content-between fs-6 m-5'>
                                        <div className='fw-semibold text-success'>{patients?.deposit && patients?.deposit != null ? `Rp. ${Number(patients?.total_deposit).toLocaleString('id-ID')}` : '0'}</div>
                                        <SButton 
                                            variant={'primary'}
                                            className={'btn-outline-primary btn-light-primary'}
                                            size={'sm'}
                                            type={'button'}
                                            action={handleUseDeposit}
                                        >
                                            Gunakan
                                        </SButton>
                                    </div>
                                </div>
                            </div>
                        }
                    />
                )}
                { showModalAdd && (
                    <ModalInfo
                        title={'Upss!'}
                        handleClose={handleCloseModal}
                        content={
                            <div>
                                <div className='d-flex flex-column mb-3'>
                                    <Form className='w-100 m-5' onSubmit={handleSubmitAddDeposit}>
                                        <span className='fw-semibold fs-6 text-gray-600 m-5'>
                                            Jumlah yang dibayarkan melebihi Grand Total, tambahkan ke deposito sekarang
                                        </span>
                                        <div className='d-flex fs-6'>
                                                <div className="row">
                                                    <div className='col-lg-12 mb-3'>
                                                        <TextInputWithLabel
                                                            id={`grand_total`}
                                                            label={'Grand Total'}
                                                            name={'grand_total'}
                                                            type={'text'}
                                                            placeholder={''}
                                                            value={modalGrandTotal.toLocaleString('id-ID')}
                                                            // onKeyDown={handleOnlyNumberInput}
                                                            style={{ backgroundColor: '#f1f1f1' }}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className='col-lg-12 mb-3'>
                                                        <TextInputWithLabel
                                                            id={`jumlah_id`}
                                                            label={'Jumlah dibayarkan'}
                                                            name={'jumlah'}
                                                            type={'text'}
                                                            placeholder={''}
                                                            value={modalJumlah.toLocaleString('id-ID')}
                                                            // onKeyDown={handleOnlyNumberInput}
                                                            style={{ backgroundColor: '#f1f1f1' }}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className='col-lg-12 mb-3'>
                                                        <TextInputWithLabel
                                                            id={`deposit_id`}
                                                            label={'Deposit'}
                                                            name={'deposit'}
                                                            type={'text'}
                                                            placeholder={''}
                                                            value={modalDeposito.toLocaleString('id-ID')}
                                                            // onKeyDown={handleOnlyNumberInput}
                                                            style={{ backgroundColor: '#f1f1f1' }}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                        </div>
                                        <div className='d-flex justify-content-end me-3'>
                                            <SButton
                                                className={'btn-secondary me-3'}
                                                variant={'secondary'}
                                                size={'sm'}
                                                action={handleCloseModal}
                                            >
                                                Close
                                            </SButton>
                                            <SButton
                                                className={'btn-primary'}
                                                variant={'primary'}
                                                size={'sm'}
                                                type={'submit'}
                                            >
                                                Submit
                                            </SButton>
                                        </div>
                                    </Form>

                                </div>
                            </div>
                        }
                    />
                )}
            </>
        )
    }

    const handleModal = () => {
        setFields(
                [
                    { type: 'hidden', name: '_id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'text', name: 'name', label: 'Full Name',classLabel: 'form-label' ,placeholder: 'Input your full name..', value: '', className: '',disable: false,required: true},
                    { type: 'text', name: 'handphone', label: 'No. Telp', classLabel: 'form-label',value: '', className: '',disable: false,required: true, onlyNumber: true},
                    { type: 'text', name: 'email', label: 'Email',classLabel: 'form-label' , placeholder: 'Input your email...', value: '', className: '',disable: false,required: true  },
                ]
        
        )
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSaveModal = () => {
        setShowModal(false);
        // setShowAlert(true); 
    }

    const handleCloseConfirm = () => {
        setShowNotif(false);
    }
    
    const handleBack = () => {
        if (window.confirm('Apakah Anda yakin ingin kembali ?')) {
            navigate(-1);
        }
    };

  return (
    <>
        {isSaving && (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(255,255,255,0.7)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    width: 60,
                    height: 60,
                    border: '6px solid #eee',
                    borderTop: '6px solid #3498db',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }} />
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        )}
        <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Breadcrumb title={'Home'} header={'POS System'} />
            <div className='app-container container-xxl d-flex'>
                <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                    <div className='d-flex flex-column flex-column-fluid'>
                        <div className='app-content'>
                            <div className='d-flex justify-content-end me-3'>
                                <SButton
                                    className={'btn-danger me-3'}
                                    variant={'danger'}
                                    size={'sm'}
                                    action={() => handleBack()}
                                >
                                    Back
                                </SButton>
                                <SButton
                                    className={'btn-secondary'}
                                    variant={'secondary'}
                                    size={'sm'}
                                    action={() => handleModal()}
                                >
                                    Pre-Settlement
                                </SButton>
                            </div>
                            <div className='d-flex flex-wrap'>
                                <HeaderPos amount={amount} />
                            </div>
                           
                        </div>
                    </div>
                    <div className='app-footer d-flex flex-column flex-md-row flex-center flex-md-stack pb-3'>
                        <div className='text-dark order-2 order-md-1'>
                            <span className='text-muted fw-semibold me-1'>2025&copy;</span>
                        </div>
                        <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                            <li className='menu-item'><span className='menu-link px-2'>About</span></li>
                            <li className='menu-item'><span className='menu-link px-2'>Support</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        {showModal && (
            <ModalForm
                show={showModal}
                handleClose={handleCloseModal}
                formDatas={fields}
                title={'Add Patient'}
                handleSave={handleSaveModal}
            />
        )}
     
        { showNotif && (
            <ShowAlert 
            title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
            message={notifMessage}
            svg={notifType === 'success' ? 'svg-icon-success' : (notifType === 'danger' ? 'svg-icon-danger' : 'svg-icon-warning')}
            show={showNotif} 
            setShow={setShowNotif}
            onClose={handleCloseConfirm}
            swal={notifType === 'success' ? 'swal2-success' : (notifType === 'danger' ? 'swal2-error' : 'swal2-warning')}
            />
        )}
    </>
  )
}

export default Checkout;